import React, {useContext, useEffect, useState} from 'react';
import Lang from '../Lang/Lang';
import {ClientWidthContext} from '../Context/ApplicationContextProvider';
import {hoverUnderlineClass, lang} from '../../common/baseData';
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import BoxIcon from './images/box-ico.svg'
import './LatestOrder.css'

function LatestOrder(props) {
  const clientWidth = useContext(ClientWidthContext);
  const swiperClass = 'swiper-latest-order';
  const [swiperInstance, setSwiperInstance] = useState(null);

  // Получение cookies
  const getCookie = (name) => {
    const cookies = document.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    return cookies[name];
  };

  // Инициализация состояния видимости последнего заказа из cookies
  const hiddenUntil = parseInt(getCookie('latestOrderHiddenUntil'), 10) || 0;
  const currentTime = Math.floor(Date.now() / 1000);
  const initialLatestOrderVisible = hiddenUntil <= currentTime;
  const [state] = useState(() => window.latestOrderData || { ORDER: null, ITEMS: [] });


  const [isLatestOrderVisible, setLatestOrderVisible] = useState(initialLatestOrderVisible); // Состояние видимости последнего заказа

  // Установка значения cookies
  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
  };

  useEffect(() => {
    if (!swiperInstance) return;
    swiperInstance.update();
  }, [clientWidth, swiperInstance, state?.ITEMS?.length]);

  // Функция для закрытия последнего заказа
  function closeLatestOrder(e) {
    e.preventDefault();
    setLatestOrderVisible(false); // Устанавливаем видимость в false
    const nextWeek = Math.floor(Date.now() / 1000) + (7 * 24 * 60 * 60); // Текущее время + 7 дней (UNIX timestamp)
    setCookie('latestOrderHiddenUntil', nextWeek, 7); // Сохраняем в cookie
  }

  const isDesktop = clientWidth >= 1280;
  const items = Array.isArray(state.ITEMS) ? state.ITEMS : [];
  const order = state.ORDER || null;
  const heedClampTitle = items.length > 2;
  const orderPageUrl = order
    ? `${lang !== 'ua' ? '/personal/order/' : '/ua/personal/order/'}?openOrderId=${order.ID}`
    : '#';
  const desktopClass = `${heedClampTitle
    ? 'line-clamp-2 overflow-hidden w-auto'
    : ''} font-normal text-[12px] leading-[18px] text-grey-90 ${hoverUnderlineClass}`;

  // Условие отображения последнего заказа
  const shouldRenderLatestOrder = !order || !items.length || !isLatestOrderVisible;
  const maxSlides = 3;
  const slidesCount = Math.min(items.length, maxSlides);
  const slidesPerViewCount = slidesCount === 1 ? 1.2 : slidesCount;

  return (
    !shouldRenderLatestOrder && (
      <div
        className="grid grid-cols-2 gap-x-[10px] gap-y-[25px] relative justify-between items-center mx-5 bg-[#F9F4FF] py-[9.5px] px-2 rounded-[14px] desktop:gap-0 desktop:mx-0 desktop:flex desktop:border-none desktop:px-4 400:gap-x-[6px]">
        {items.length > 0 && (
          <>
            <div
              className='flex shrink-0 items-center gap-2 text-black font-normal text-[14px] leading-[21px] desktop:text-[13px] desktop:leading-[20px] desktop:min-w-[160px] desktop:max-w-[160px] 400:text-[12px] 400:leading-[16px]'>
              <img src={BoxIcon} alt=""/>
              <div className="flex flex-col gap-[2px]">
                <span className="text-black font-medium">{Lang.getMessage('latestOrderNumber').replace('#NUMBER#', order.ACCOUNT_NUMBER)}</span>
                <span className="text-grey-40">{Lang.getMessage('latestOrderDate').replace('#DATE#', order.DATE_INSERT_FORMAT)}</span>
              </div>
            </div>

            <span
              className="absolute w-[calc(100%-16px)] h-[0.5px] bg-[#D9CCE8] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 desktop:hidden"></span>

            <div
              className="latest-order-items w-full overflow-hidden scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar cursor-col-resize order-3 phone:flex-wrap phone:max-h-[40px] phone:overflow-hidden phone:w-auto desktop:px-[35px] desktop:order-none">
              <Swiper
                modules={[FreeMode, Navigation]}
                onSwiper={setSwiperInstance}
                navigation={{
                  prevEl: `.swiper-button-prev-latest.${swiperClass}`,
                  nextEl: `.swiper-button-next-latest.${swiperClass}`,
                }}
                freeMode={true}
                speed={600}
                slidesPerView={clientWidth < 500 ? 'auto' : 'auto'}
                spaceBetween={8}
                breakpoints={{
                  500: { slidesPerView: slidesPerViewCount, spaceBetween: 8 },
                  767: { slidesPerView: slidesPerViewCount, spaceBetween: 8 },
                  1280: { slidesPerView: slidesPerViewCount, spaceBetween: 20, freeMode: false },
                }}
              >
                {items.map((item) => (
                  <SwiperSlide key={`latest-order-item-${item.ID}`}>
                    <div className="flex gap-2 items-center">
                      <span
                        className="flex items-center justify-center border-solid border-[0.5px] border-grey-15 bg-white overflow-hidden rounded-[12px] h-10 w-10 min-w-10">
                        <img src={item.IMAGE_150_SRC} className="h-full w-full object-cover" width="32px" height="32px"
                             loading="eager"/>
                      </span>
                      <a href={item.LINK} className={`line-clamp-2 500:hidden ${desktopClass}`}>{item.NAME}</a>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className={`swiper-button-prev-latest ${swiperClass} ${!isDesktop ? '!hidden' : ''}`}/>
              <div className={`swiper-button-next-latest ${swiperClass} ${!isDesktop ? '!hidden' : ''}`}/>
            </div>

            <div className="order-2 flex shrink-0 whitespace-nowrap justify-end font-medium desktop:order-none 400:text-[12px]">{order.STATUS_NAME}</div>

            <a href={orderPageUrl}
               className='text-center order-4 w-max ml-auto relative text-blue-primary px-4 text-[14px] leading-[21px] py-3 border-blue-primary border border-solid rounded-[14px] mr-[20px] desktop:min-w-[123px] desktop:w-[123px] desktop:ml-[22px] desktop:mr-[35px] desktop:order-none 400:text-[12px] 400:leading-[16px] 400:py-2.5'>
              {Lang.getMessage('latestOrderView')}
            </a>

            <a href={"#"} className={`absolute bottom-[23px] border-none right-2 desktop:right-4 desktop:top-1/2 desktop:-translate-y-1/2 400:bottom-[19px]`}
               onClick={closeLatestOrder}>
              <i className="ic-close-sm"></i>
            </a>
          </>
        )
        }
      </div>
    )
  );
}

export default LatestOrder;
